var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "modalDeactivateUser",
      "modal-class": "confirmation-modal",
      "title": "Deactivate User",
      "ok-variant": "danger",
      "ok-title": "Yes",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading
    },
    on: {
      "ok": _vm.handleDeactivateModalOk
    }
  }, [_vm._v(" Are you sure you want to deactivate this user? ")]), _c('b-modal', {
    attrs: {
      "id": "modalAskForUserAccess",
      "modal-class": "confirmation-modal",
      "title": "Deactivate User",
      "cancel-title": _vm.shouldAskForDeactivationReview ? 'No' : 'No, just deactivate',
      "ok-variant": "danger",
      "ok-title": "Yes",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading
    },
    on: {
      "cancel": _vm.inactivateUser,
      "ok": _vm.askForUserAccessModalOk
    }
  }, [_vm._v(" Do you require access to this User’s Motto email account? ")]), _c('b-modal', {
    attrs: {
      "id": "modalAskForConfirmationThirdParty",
      "modal-class": "confirmation-modal",
      "title": "Deactivate User",
      "cancel-title": "Cancel",
      "ok-variant": "danger",
      "ok-title": "Deactivate",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading
    },
    on: {
      "ok": _vm.inactivateUser
    }
  }, [_vm._v(" This deactivates the user’s MottoCenter and MottoLearn accounts only. To deactivate this user in wemlo LBS, login to your wemlo LBS brokerage account, click on My account, select Roles, scroll down to the processors section, and toggle the status indicator to Inactive. ")]), _c('ValidationObserver', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var modalValidationFailed = _ref.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "modalAccessibleTerminateUser",
            "modal-class": "confirmation-modal",
            "title": "Deactivate User",
            "ok-variant": "danger",
            "ok-title": "Submit",
            "cancel-disabled": _vm.modalButtonLoading,
            "ok-disabled": _vm.modalButtonLoading || modalValidationFailed || !_vm.mottoForwardEmail,
            "centered": true
          },
          on: {
            "cancel": _vm.openDeactivateUserModal,
            "ok": _vm.accessibleTerminateUser
          }
        }, [_vm._v(" Please enter the Motto email where you would like to receive the password reset email for this account. "), _c('PersonnelFormItem', {
          staticClass: "mt-4",
          attrs: {
            "label": "Motto forwarding email",
            "value": _vm.mottoForwardEmail,
            "edit-mode": "",
            "rules": "required|email|mottoEmailDomain",
            "placeholder": "Email"
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.mottoForwardEmail = $event;
            }
          }
        })], 1)];
      }
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "modalAskForActiveLoanFiles",
      "modal-class": "confirmation-modal",
      "title": "Deactivate User",
      "cancel-title": "No, just deactivate",
      "ok-variant": "danger",
      "ok-title": "Yes",
      "centered": true,
      "cancel-disabled": _vm.modalButtonLoading,
      "ok-disabled": _vm.modalButtonLoading
    },
    on: {
      "cancel": _vm.askForReasonForTermination,
      "ok": _vm.askForActiveLoanFilesOk
    }
  }, [_vm._v(" Is this user assigned to any active loan files? ")]), _c('ValidationObserver', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var modalValidationFailed = _ref2.failed;
        return [_c('b-modal', {
          attrs: {
            "id": "modalAskForActiveLoansFilesAssignment",
            "modal-class": "confirmation-modal",
            "title": "Deactivate User",
            "cancel-title": "Cancel",
            "ok-variant": "danger",
            "ok-title": "Submit",
            "centered": true,
            "cancel-disabled": _vm.modalButtonLoading,
            "ok-disabled": _vm.modalButtonLoading || modalValidationFailed || !_vm.assignFilesTo
          },
          on: {
            "ok": _vm.askForReasonForTermination
          }
        }, [_c('PersonnelFormItem', {
          staticClass: "mt-4",
          attrs: {
            "label": "Who should those files be assigned to?",
            "value": _vm.assignFilesTo,
            "edit-mode": "",
            "rules": "required"
          },
          on: {
            "update:value": function updateValue($event) {
              _vm.assignFilesTo = $event;
            }
          }
        })], 1)];
      }
    }])
  }), _c('ValidationObserver', [_c('b-modal', {
    attrs: {
      "id": "modalAskForReasonForTermination",
      "modal-class": "confirmation-modal",
      "title": "Reason for Termination",
      "ok-variant": "danger",
      "ok-title": "Deactivate",
      "cancel-variant": "space-only",
      "centered": true,
      "ok-disabled": _vm.modalButtonLoading || !_vm.terminationReasonLoPhaseTwo || _vm.terminationReasonLoPhaseTwo === 'Other' && !_vm.terminationReasonLoPhaseTwoOther
    },
    on: {
      "ok": _vm.askForDeactivationReview
    }
  }, [_vm._v(" Your honest feedback is invaluable and will be used to make meaningful improvements in our organization. Please know that your responses will be kept confidential. "), _c('FormItem', {
    staticClass: "mt-4 flex-shrink-0",
    attrs: {
      "label": "Reason For Termination",
      "edit-mode": "",
      "value": _vm.terminationReasonLoPhaseTwo,
      "edit-select-values": _vm.reasonsForTermination,
      "options": {
        hideLabel: true
      },
      "rules": "required",
      "placeholder": "Select..."
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.terminationReasonLoPhaseTwo = $event;
      }
    }
  }), _c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.terminationReasonLoPhaseTwo === 'Other',
      expression: "terminationReasonLoPhaseTwo === 'Other'"
    }],
    staticClass: "mt-4",
    attrs: {
      "textarea": "",
      "label": "Other",
      "rules": "max:250|required",
      "character-limit-options": {
        showOnlyError: true
      },
      "value": _vm.terminationReasonLoPhaseTwoOther,
      "options": {
        hideLabel: true
      },
      "edit-mode": ""
    },
    on: {
      "update:value": function updateValue($event) {
        _vm.terminationReasonLoPhaseTwoOther = $event;
      }
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }